<template>
<div
    v-if="organization != null"
    style="position: relative;"
>
    <h2>{{organization.label}}</h2>

    <p
        style="margin-top: 5px"
    >
        <table
            class="details"
        >
            <tr><td>State</td><td>{{organization.organization_state}}</td></tr>
            <tr><td>Organization Id</td><td class="technical">{{organization.organization_id}}</td></tr>
            <tr><td>Creation Date</td><td>{{organization.creation_date}}</td></tr>
            <tr><td>Industry</td><td>{{organization.industry}}</td></tr>
            <tr><td>Integrations</td><td>{{$rc.pretty(organization.active_integrations,'comma_list')}}</td></tr>
            <tr><td>Location</td><td>{{organization.country_and_subdivision}}</td></tr>
            <tr><td>Timezone</td><td>{{organization.primary_timezone}}</td></tr>
            <tr><td>Prospective</td><td><v-simple-checkbox disabled :value="organization.is_prospective_organization"/></td></tr>
            <tr><td>Archived</td><td><v-simple-checkbox disabled :value="organization.is_archived"/></td></tr>
            <tr><td>Non-Revenue</td><td><v-simple-checkbox disabled :value="!organization.is_revenue_account"/></td></tr>
            <tr><td>Organization Origin (a.k.a. Promos)</td><td><m-rc-tag-display :value="organization.rc_tag_ids"/></td></tr>

            <tr>
                <td
                    valign="top"
                >
                    Links
                </td>
                <td>
                    <a class="link" v-on:click="onClickProvision">Provision Screen...</a><br/>
                    <a class="link" v-on:click="onClickWelcomeScreen">Welcome Screen...</a><br/>
                    <a class="link" v-on:click="onClickOrganizationSettings">Organization Settings...</a><br/>
                </td>
            </tr>

        </table>
    </p>

    <div
        style="position: absolute; right: 0px; top: 0px"
    >
        <v-menu 
            bottom 
            offset-y  
        >
        
        <template v-slot:activator="{ on }">
                
            <v-icon 
                v-on="on"
            >
                mdi-dots-vertical
            </v-icon>
                
        </template>
        
        <v-list>

            <v-list-item
                v-on:click="$refs['edit-dialog'].showDialog(organization)"
            >
                <v-list-item-title>Edit Organization General Info...</v-list-item-title>
            </v-list-item>

            <v-list-item
                v-on:click="onClickSetState('active')"
                v-if="organization.organization_state == 'pre-launch'"
            >
                <v-list-item-content>
                    <v-list-item-title>Move from pre-launch to active state</v-list-item-title>
                </v-list-item-content>
            </v-list-item>

            <v-list-item
                v-on:click="onClickSetState('pre-launch')"
                v-if="organization.organization_state == 'active'"
            >
                <v-list-item-content>
                    <v-list-item-title>Return to pre-launch state</v-list-item-title>
                </v-list-item-content>
            </v-list-item>

            <v-divider/>

            <v-list-item
                v-on:click="onClickSignInAs()"
                :disabled="organization.is_prospective_organization"
            >
                <v-list-item-title>Sign in as...</v-list-item-title>
            </v-list-item>

            <v-divider/>

             <v-list-item
                v-on:click="onClickCreateOrganization()"
                v-if="organization.is_prospective_organization"
            >
                <v-list-item-title>Create organization...</v-list-item-title>
            </v-list-item>

        
        </v-list>
        
        </v-menu> 

    </div>

     <m-edit-rc-crm-organization-dialog
        ref='edit-dialog'
        v-on:input="afterUpdate"
    />

    <m-admin-org-sign-in-as-dialog
        ref="admin-org-sign-in-as-dialog"
    />

</div>   
</template>

<script>
export default {

    data() {
        return {
            organization: null,
        }
    },

    mounted () {
        this.updateOrganization();
    },

    methods: {
        updateOrganization() {
            
            this.$rc.rest(
                'GET: /api/v1/red-chirp-crm/organizations/admin-summary/:organization_id',
            
                {
                    'organization_id': this.$route.params.organization_id
                },
            
                (data) => {
                    this.organization = data;
                    this.$emit('update-organization',this.organization);
                },
            
                () => {
                    this.$rc.alert('Error','Unable to get organization meta data');
                },
            );
        },

        afterUpdate(meta_data)
        {
            this.organization = meta_data;
            this.$emit('update-organization',this.organization);
        },

        onClickSetState(new_state)
        {
            this.$rc.rest({
                'spinner': false,
                'endpoint': 'PATCH: /api/v1/organizations/organization-account',
            
                'params' : {
                    'organization_id': this.organization.organization_id,
                    'organization_state': new_state,
                    },
            
                'on_success': (data) => {
                        this.updateOrganization();
                    },
            
                'on_error': 'Unable to change organization state.',
            });
        },

        onClickSignInAs()
        {
            this.$refs['admin-org-sign-in-as-dialog'].showDialog(this.organization);
        },

        onClickCreateOrganization()
        {
            this.$router.push(
                { 
                    name: 'admin-create-organization', 
                    params: { 
                        'organization_id': this.organization.organization_id,
                    } 
                }
            );
        },

        onClickProvision()
        {
            this.$router.push({
                'name': 'provision',
                'params' : {
                    'organization_id': this.organization.organization_id,
                }
            });
        },

        onClickWelcomeScreen()
        {
            if ( this.organization.employee_account_any_org_admin == null )
            {
                this.$rc.alert('Unable to navigate to welcome screen','This organization does not have an organization admin account.  Because of this, the welcome screen can not be accessed');
                return;
            }

            this.$router.push({
                'name': 'welcome_ordinary_user',
                'params' : {
                    'employee_id': this.organization.employee_account_any_org_admin.employee_id,
                }
            });
        },

        onClickOrganizationSettings()
        {
            this.$router.push({
                'name': 'settings-organization',
                'params' : {
                    'organization_id': this.organization.organization_id,
                }
            });
        },
    },
}
</script>

<style lang="scss" scoped>

table.details
{
    border-collapse: collapse,
}


table.details tr td
{
    padding-left: 10px;
    padding-top: 3px;
    padding-bottom: 3px;
}

table.details tr td:first-of-type
{
    font-weight: bold;
    text-align: right;
    border-right: 1px solid rgba(0,0,0,0.1);
    padding-right: 10px;
    padding-left: 0px;
}


.technical
{
    font-family: 'Courier New', Courier, monospace

}

.link:hover
{   
    text-decoration: underline;
}


</style>